<template>
  <div v-if="goodsObj.user === undefined"></div>
  <div class="pos" v-else>
    <div class="nav">
      <van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
      <span>我的闲具</span>
      <span></span>
    </div>
    <!-- 关于卖家 -->
    <div class="user-msg" @click="toPos()">
      <!-- <div>关于卖家</div> -->
      <div class="contain">
        <div class="contain-left">
          <img src="../../assets/user.png" alt="" v-if="goodsObj.user.image === null">
          <img :src="goodsObj.user.image | handleUrl" alt="" v-else>
          <div>
            <div>{{goodsObj.user.username}}</div>
            <div>
              <span>商家很懒，暂无介绍~</span>
            </div>
          </div>
        </div>
        <div class="contain-right">
          <div>在售宝贝</div>
          <div>{{goodsObj.count}}</div>
        </div>
      </div>
    </div>
    <!-- 商品列表 -->
    <div class="like">
      <div class="section">
        <div class="list" v-for="item in goodsObj.data" @click="goDetail(item.id)">
          <img :src="item.image[0] | handleUrl" alt="">
          <div class="foot-tips">
            <div>
              <div>{{item.title}}</div>
              <div class="main-tag">
                <span class="primary" v-if="item.category==1">个人转让</span>
                <span class="primary" v-else>商家出售</span>
                <span class="primary">{{item.new_old}}</span>
              </div>
              <div class="vangrid-right">
                <span class="f1452f font-5">{{item.price | formarter}}</span>
                <span>{{item.city}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-divider :style="{ color: '#969799', borderColor: '#969799', padding: '0 5.5rem' }">
        我是有底线的~
      </van-divider>
    </div>
    <van-goods-action>
      <van-goods-action-icon icon="wap-home-o" text="首页" to="/Home" />
      <van-goods-action-icon icon="like-o" text="收藏" />
      <van-goods-action-button type="danger" text="拨打电话" @click="callPhone(goodsObj.user.tel)" />
    </van-goods-action>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        goodsObj: {},
        id: this.$route.query.id
      }
    },
    created() {
      this.$axios.post(baseUrl + '/mobile/Fta/ftaGoods', {
        user_id: this.$route.query.id
      }).then((res) => {
        if (res.data.code == 2) {
          this.goodsObj = res.data.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    methods: {
      goDetail(id) {
        this.$router.push({
          path: '/undeteDteil',
          query: {
            id: id
          }
        })
      },
      // 调用拨号功能
      callPhone(phoneNumber) {
        window.location.href = 'tel://' + phoneNumber
      }
    }
  }
</script>

<style scoped>
  @import '../../components/like/like.css';

  .pos {
    padding-top: 2rem;
  }

  .pos .user-msg {
    background: #fff;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    box-sizing: border-box;
    text-align: left;
    margin: 0.5rem 0;
  }

  .pos .user-msg>div:nth-child(1) {
    font-size: 0.75rem;
    color: #333333;
    margin-bottom: 0.3rem;
  }

  .pos .user-msg .contain {
    display: flex;
    font-size: 0.75rem;
    margin-top: 0.5rem;
  }

  .pos .user-msg .contain-left {
    display: flex;
    width: 80%;
    border-right: 1px solid #f0eff5;
  }

  .pos .user-msg .contain-left a {
    color: #F1452F;
  }

  .pos .user-msg .contain-left>div {
    display: flex;
    padding-right: 0.5rem;
    flex-direction: column;
    justify-content: space-around;
  }

  .pos .user-msg .contain-left img {
    width: 4rem;
    height: 4rem;
    border-radius: 0.4rem;
    margin-right: 1rem;
  }

  .pos .user-msg .contain-right {
    padding-left: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 20%;
    color: #9d9d9d;
  }

  .pos .danger {
    color: #F1452F;
    border: 1px solid #F1452F;
    border-radius: 0.2rem;
    font-size: 12px;
    padding: 0 0.2rem;
  }

  .pos .main-tag {
    font-size: 0.75rem;
    margin: 0.5rem 0;
  }

  .pos .primary {
    color: #3ea6ef;
    border: 1px solid #3ea6ef;
    border-radius: 0.2rem;
    font-size: 12px;
    padding: 0 0.2rem;
    margin-right: 0.2rem;
  }

  .pos .vangrid-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pos .vangrid-right span {
    margin-top: 0 !important;
  }

  .pos .vangrid-right .f1452f {
    color: #F1452F;
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/pos.vue